import { useState } from 'react'
import CompanyNavbar from 'components/Navbars/CompanyNavbar'
import Plans from './Plans'
import Members from './Members'
import { Container, TabRow, TabButton } from './styles'

export default function Home () {
  const TAB_LIST = [
    {label: 'Planos', value: 'plans', component: <Plans/>},
    {label: 'Colaboradores', value: 'members', component: <Members/>},
  ]
  
  const [selectedTab, setSelectedTab] = useState (
    localStorage.getItem ('company_section') || TAB_LIST[0].value
  )

  return (
    <Container>
      <CompanyNavbar/>
      <TabRow>
        {TAB_LIST.map (s => (
          <TabButton
            key={s.value}
            selected={selectedTab === s.value}
            onClick={() => {
              setSelectedTab (s.value)
              localStorage.setItem ('company_section', s.value)
            }}
          >
            {s.label}
          </TabButton>
        ))}
      </TabRow>
      {TAB_LIST.find (s => s.value === selectedTab).component}
    </Container>
  )
}
